import React from "react";
// import { useNavigate } from "react-router-dom";
import ExploreSharpIcon from '@mui/icons-material/ExploreSharp';
import { Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import useTailwindBrand from "../../Theme/useTailwindBrand";
import type Teachr from "../../Objects/models/Teachr";

export type HomeTabId = "start" | "resume" | "revenus" | "all-bord";

export interface HomeHeaderProps {
  teachr?: Teachr;
  // profileCompletion?: number;
  title?: string;
  subtitle?: string;
  children?: React.ReactNode
  subChildren?: React.ReactNode
  currentLevel?: { name: string; emoji: string };
  notification?: {
    title: string
    label: string
  }
}

const DEFAULT_SUBTITLE =
  "Retrouvez vos actions rapides et vos derniers guides.";

const HomeHeader: React.FC<HomeHeaderProps> = ({
  teachr,
  // profileCompletion = 0,
  title,
  subtitle,
  children,
  subChildren,
  currentLevel,
  notification
}) => {
  const { brandConfig } = useTailwindBrand();
  const firstName = teachr?.firstName ?? "";
  const displayTitle =
    title ?? `Bonjour${firstName ? `, ${firstName}` : ""} 👋`;
  const displaySubtitle = subtitle ?? DEFAULT_SUBTITLE;

  return (
    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 /mb-4">
      <div className="flex-1">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          flexWrap="wrap"
          gap={2}
          className="mb-6"
        >
          <Box>
            <Typography
              variant="h5"
              sx={{
                mb: 0.5,
                fontFamily: brandConfig.fontFamily,
                color: brandConfig.colors.primary,
              }}
              className="font-bold"
            >
              {displayTitle}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontFamily: brandConfig.fontFamily }}
            >
              {displaySubtitle}
            </Typography>
          </Box>
          {subChildren}
          <Stack direction="row" spacing={2} alignItems="center" className={notification ? '' : 'hidden'}>
            <Tooltip title={notification?.title}>
              <Chip
                icon={< TrendingUpIcon />}
                label={notification?.label}
                color="primary"
                variant="outlined"
                size="small"
              />
            </Tooltip>
            {currentLevel && (
            <Tooltip title={`Niveau ${teachr?.level ?? 1} : ${currentLevel?.name} ${currentLevel?.emoji}`}>
              <Chip
                icon={<ExploreSharpIcon className="text-white" />}
                // icon={<CheckCircleOutlineIcon />}
                label={`Niveau ${teachr?.level ?? 1} : ${currentLevel?.name} ${currentLevel?.emoji}`}
                sx={{ backgroundColor: brandConfig.colors.secondary, color: "white" }}
                className={`rounded-md font-bold`}
                // size=""
              />
            </Tooltip>)}
          </Stack>
        </Stack>
        {children}
      </div>
    </div>
  );
};

export default HomeHeader;
